import React, { useState } from 'react';
import {
    Table, Button, Space, Input, message, Typography, Modal, Tag, Transfer
} from 'antd';
import { PlusOutlined, SearchOutlined, ReloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// ============================================================
// Mock数据 — TODO: 联调时替换为接口
// ============================================================

// 物模型管理-事件库 的事件全量数据（与 EventLibrary.js 的 INIT_EVENTS 对应）
const MOCK_EVENT_LIBRARY = [
    { eventId: 100000, eventName: '移动检测', descr: '检测到物体移动时触发' },
    { eventId: 100001, eventName: '人形识别', descr: '检测到人形时触发' },
    { eventId: 100002, eventName: '人脸识别', descr: '识别到已注册人脸时触发' },
    { eventId: 100005, eventName: 'PIR人体侦测', descr: 'PIR传感器检测到人体时触发' },
    { eventId: 100015, eventName: '人脸检测', descr: '画面中出现人脸时触发' },
    { eventId: 100017, eventName: '门铃呼叫', descr: '设备门铃被按下时触发' },
    { eventId: 100400, eventName: '声音检测', descr: '检测到异常声音时触发' },
    { eventId: 101201, eventName: '低电检测', descr: '设备电量低于阈值时触发' },
    { eventId: 102400, eventName: '跌倒检测', descr: '检测到人员跌倒时触发' },
    { eventId: 102500, eventName: '火焰检测', descr: '检测到火焰时触发' },
    { eventId: 102600, eventName: '烟雾检测', descr: '检测到烟雾时触发' },
    { eventId: 102800, eventName: '哭声检测', descr: '检测到婴儿哭声时触发' },
    { eventId: 102900, eventName: '宠物检测', descr: '检测到宠物时触发' },
    { eventId: 103700, eventName: '一键呼叫-语音', descr: '设备发起语音呼叫' },
    { eventId: 106900, eventName: '儿童靠近危险区', descr: '儿童靠近危险区域' },
    { eventId: 107900, eventName: '区域闯入', descr: '物体进入禁止区域' },
    { eventId: 108200, eventName: '烟火侦测', descr: '检测到烟火时触发' },
    { eventId: 108300, eventName: '车辆侦测', descr: '检测到车辆时触发' },
    { eventId: 109300, eventName: '设备离线', descr: '设备断开连接' },
    { eventId: 109600, eventName: '智能告警-儿童检测', descr: '综合儿童检测告警' },
    { eventId: 110600, eventName: '宠物异常行为', descr: '宠物异常行为告警' },
    { eventId: 300000, eventName: '定时抓拍', descr: '按设定时间间隔抓拍' },
    { eventId: 300001, eventName: '手动抓拍', descr: '用户手动触发抓拍' },
];

// 初始已选触发事件（平台运营从事件库中选入 Agent 可用的事件）
const INIT_SELECTED_EVENTS = [
    { eventId: 100000, eventName: '移动检测', descr: '检测到物体移动时触发' },
    { eventId: 100400, eventName: '声音检测', descr: '检测到异常声音时触发' },
    { eventId: 100001, eventName: '人形识别', descr: '检测到人形时触发' },
    { eventId: 102900, eventName: '宠物检测', descr: '检测到宠物时触发' },
    { eventId: 108300, eventName: '车辆侦测', descr: '检测到车辆时触发' },
    { eventId: 100017, eventName: '门铃呼叫', descr: '设备门铃被按下时触发' },
    { eventId: 102600, eventName: '烟雾检测', descr: '检测到烟雾时触发' },
    { eventId: 102500, eventName: '火焰检测', descr: '检测到火焰时触发' },
];

// 导出事件名称列表，供 AgentConfig 的「触发事件类型」Checkbox 使用
export const MOCK_TRIGGER_EVENT_NAMES = INIT_SELECTED_EVENTS.map(e => e.eventName);

// Agent 列表（用于计算各事件的「已应用agent」—— 扫描所有 Agent 的 eventTypes）
const MOCK_AGENTS = [
    { agentId: 'test-agent-001', name: '家庭安防智能看护', status: 'published',
        eventTypes: ['移动检测', '人形识别', '声音检测', '门铃呼叫', '烟雾检测'] },
    { agentId: 'agent-pet-002', name: '宠物监护Agent', status: 'published',
        eventTypes: ['宠物检测', '移动检测'] },
    { agentId: 'agent-baby-003', name: '婴儿监护Agent', status: 'draft',
        eventTypes: ['声音检测', '移动检测'] },
    { agentId: 'agent-elder-004', name: '老人看护Agent', status: 'published',
        eventTypes: ['人形识别', '声音检测', '火焰检测', '烟雾检测'] },
    { agentId: 'agent-parking-005', name: '车位看护Agent', status: 'published',
        eventTypes: ['车辆侦测', '移动检测'] },
];

const STATUS_MAP = { draft: { text: '草稿', color: 'default' }, published: { text: '已发布', color: 'green' }, offline: { text: '已下线', color: 'red' } };

const TriggerEventManage = () => {
    // 已选触发事件列表
    const [selectedEvents, setSelectedEvents] = useState([...INIT_SELECTED_EVENTS]);
    const [searchKeyword, setSearchKeyword] = useState('');

    // 添加事件 Modal
    const [addModalOpen, setAddModalOpen] = useState(false);
    // Transfer 选中的目标 key（eventId）
    const [targetKeys, setTargetKeys] = useState([]);

    // 已应用Agent详情 Modal
    const [appliedModalOpen, setAppliedModalOpen] = useState(false);
    const [appliedAgents, setAppliedAgents] = useState([]);
    const [currentEventName, setCurrentEventName] = useState('');

    // ============================================================
    // 计算
    // ============================================================

    // 获取某个事件的已应用Agent列表
    const getAppliedAgents = (eventName) => {
        return MOCK_AGENTS.filter(a => a.eventTypes && a.eventTypes.includes(eventName));
    };

    // 搜索过滤
    const filteredEvents = selectedEvents.filter(e => {
        if (!searchKeyword) return true;
        const kw = searchKeyword.toLowerCase();
        return String(e.eventId).includes(kw) || e.eventName.toLowerCase().includes(kw);
    });

    // Transfer 数据源：事件库全部事件
    const transferDataSource = MOCK_EVENT_LIBRARY.map(e => ({
        key: String(e.eventId),
        title: e.eventName,
        description: e.descr || '',
    }));

    // ============================================================
    // 操作
    // ============================================================

    const showAppliedModal = (eventName) => {
        setAppliedAgents(getAppliedAgents(eventName));
        setCurrentEventName(eventName);
        setAppliedModalOpen(true);
    };

    // 打开添加事件 Modal：已选中的事件回显 targetKeys
    const openAddModal = () => {
        setTargetKeys(selectedEvents.map(e => String(e.eventId)));
        setAddModalOpen(true);
    };

    // 确认添加：根据 targetKeys 从事件库中取事件
    const handleAddConfirm = () => {
        const newEvents = MOCK_EVENT_LIBRARY
            .filter(e => targetKeys.includes(String(e.eventId)))
            .map(e => ({ eventId: e.eventId, eventName: e.eventName, descr: e.descr }));
        setSelectedEvents(newEvents);
        message.success(`已更新触发事件列表，共 ${newEvents.length} 个事件`);
        setAddModalOpen(false);
    };

    // 移除事件（受 Agent 引用保护）
    const handleRemoveEvent = (record) => {
        const agents = getAppliedAgents(record.eventName);
        if (agents.length > 0) {
            message.warning(`该事件被 ${agents.length} 个Agent使用，无法移除`);
            return;
        }
        setSelectedEvents(prev => prev.filter(e => e.eventId !== record.eventId));
        message.success('事件已移除');
    };

    // ============================================================
    // 表格列定义
    // ============================================================
    const columns = [
        {
            title: '事件ID', dataIndex: 'eventId', key: 'eventId', width: 120,
            render: (v) => <Tag color="processing" style={{ fontFamily: 'monospace', fontSize: 12, border: 'none' }}>{v}</Tag>,
        },
        {
            title: '事件名称', dataIndex: 'eventName', key: 'eventName', width: 160,
            render: (v) => <Text strong>{v}</Text>,
        },
        {
            title: '已应用Agent', key: 'appliedAgents', width: 150, align: 'center',
            render: (_, record) => {
                const count = getAppliedAgents(record.eventName).length;
                return count > 0 ? (
                    <Button type="link" size="small" onClick={() => showAppliedModal(record.eventName)}>
                        {count} 个
                    </Button>
                ) : (
                    <Text type="secondary">0</Text>
                );
            },
        },
        {
            title: '事件描述', dataIndex: 'descr', key: 'descr', ellipsis: true,
            render: (v) => <Text type="secondary" style={{ fontSize: 13 }}>{v || '—'}</Text>,
        },
        {
            title: '操作', key: 'action', width: 100,
            render: (_, record) => {
                const count = getAppliedAgents(record.eventName).length;
                return (
                    <Button
                        type="link" size="small" danger
                        disabled={count > 0}
                        title={count > 0 ? `该事件被 ${count} 个Agent使用，无法移除` : ''}
                        onClick={() => handleRemoveEvent(record)}
                    >
                        移除
                    </Button>
                );
            },
        },
    ];

    // 已应用Agent弹窗的列
    const appliedColumns = [
        { title: 'Agent名称', dataIndex: 'name', key: 'name', render: (v) => <Text strong>{v}</Text> },
        { title: 'Agent ID', dataIndex: 'agentId', key: 'agentId', width: 180, render: (v) => <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{v}</Text> },
        {
            title: '状态', dataIndex: 'status', key: 'status', width: 80, align: 'center',
            render: (v) => {
                const s = STATUS_MAP[v] || { text: v, color: 'default' };
                return <Tag color={s.color} style={{ border: 'none' }}>{s.text}</Tag>;
            },
        },
    ];

    // ============================================================
    // 渲染
    // ============================================================
    return (
        <div style={{ padding: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
                <Space direction="vertical" size={2}>
                    <Title level={4} style={{ margin: 0 }}>触发事件管理</Title>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        从物模型管理的事件库中选择事件，作为 Agent 配置中「触发事件类型」的数据源
                    </Text>
                </Space>
                <Button type="primary" icon={<PlusOutlined />} onClick={openAddModal}>
                    添加事件
                </Button>
            </div>

            <div style={{ marginBottom: 16 }}>
                <Space>
                    <Input
                        placeholder="搜索事件ID或名称"
                        allowClear
                        style={{ width: 260 }}
                        prefix={<SearchOutlined />}
                        value={searchKeyword}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                    />
                    <Button icon={<ReloadOutlined />} onClick={() => setSearchKeyword('')}>重置</Button>
                </Space>
            </div>

            <Table
                columns={columns}
                dataSource={filteredEvents}
                rowKey="eventId"
                pagination={{
                    showTotal: (total) => `共 ${total} 条`,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50'],
                }}
                size="middle"
                locale={{ emptyText: '暂无触发事件，请点击「添加事件」从事件库中选择' }}
            />

            {/* ============================================================ */}
            {/* 添加事件 Modal — 从事件库选择 */}
            {/* ============================================================ */}
            <Modal
                title="从事件库选择触发事件"
                open={addModalOpen}
                onCancel={() => setAddModalOpen(false)}
                onOk={handleAddConfirm}
                okText="确认选择"
                cancelText="取消"
                width={700}
                destroyOnClose
            >
                <Text type="secondary" style={{ display: 'block', marginBottom: 16, fontSize: 13 }}>
                    以下为物模型管理 → 事件库中的全部事件，请勾选需要作为触发事件类型使用的选项，确认后替换当前列表。
                </Text>
                <Transfer
                    dataSource={transferDataSource}
                    targetKeys={targetKeys}
                    onChange={(nextTargetKeys) => setTargetKeys(nextTargetKeys)}
                    render={(item) => (
                        <div>
                            <Text strong style={{ fontSize: 13 }}>{item.title}</Text>
                            <br />
                            <Text type="secondary" style={{ fontSize: 11 }}>{item.description}</Text>
                        </div>
                    )}
                    listStyle={{ width: 280, height: 420 }}
                    showSearch
                    filterOption={(inputValue, item) =>
                        item.title.toLowerCase().includes(inputValue.toLowerCase())
                    }
                    titles={['事件库（全部）', '已选触发事件']}
                    locale={{ searchPlaceholder: '搜索事件名称', itemUnit: '个', itemsUnit: '个' }}
                />
            </Modal>

            {/* ============================================================ */}
            {/* 已应用Agent 详情 Modal */}
            {/* ============================================================ */}
            <Modal
                title={<Space><ExclamationCircleOutlined />已应用「{currentEventName}」的Agent</Space>}
                open={appliedModalOpen}
                onCancel={() => setAppliedModalOpen(false)}
                footer={null}
                width={560}
            >
                {appliedAgents.length > 0 ? (
                    <Table
                        columns={appliedColumns}
                        dataSource={appliedAgents}
                        rowKey="agentId"
                        size="small"
                        pagination={false}
                    />
                ) : (
                    <div style={{ textAlign: 'center', padding: 24, color: '#999' }}>暂无Agent使用该事件</div>
                )}
            </Modal>
        </div>
    );
};

export default TriggerEventManage;
